<vp-mini-carousel
	[aspectRatio]="aspectRatio"
	[editableInStoryblok]="_editable()"
	[items]="carouselItems"
/>
